export default "__VITE_ASSET__B9a6SJ0p__"